<template>
  <div class="event-con-list">
      <a href="#" @click.prevent="goToContentDetail()" class="event-con-list-anchor">
        <div class="picture-area">
          <WebpImage :image-info="{imageUrl: image, width: 176, height: 264, alt: `${imgAlt} 포스터`}" />
        </div>
        <div class="event-con-desc-wrap">
          <strong v-if="title" class="event-con-tit">{{ title }}</strong>

          <table>
            <caption>Content Info Table</caption>
            <template v-for="(tr, index) in tableList">
              <tr
                v-if="tr.isShow"
                :class="[
                  `event-con-desc`,
                  {'event-synopsis' : tr.key === 'synopsis'},
                  {'event-desc-actor' : tr.key === 'actor'},
                  {'event-desc-director' : tr.key === 'director'}
                ]"
                :key="index"
              >
                <th><span class="event-desc-strong">{{ tr.title }}</span></th>
                <td><span class="event-desc-detail">{{ tr.value }}</span></td>
              </tr>
            </template>
          </table>
        </div>
      </a>
  </div>
</template>

<script>
import _ from 'lodash'
import { stringify } from 'query-string'
import utils from '@/common/util/utils'
import WebpImage from '@/components/image/WebpImage'

export default {
  name: 'EventContent',
  components: {
    WebpImage
  },
  data () {
    return {
      device: utils.cookies.getDevice()
    }
  },
  props: {
    contentInfo: {
      type: Object,
      default: null
    },
    contentType: {
      type: String, // 'movie | vod
      default: ''
    }
  },
  computed: {
    actor () {
      return _.get(this.contentInfo, 'actor', '').replaceAll(/,(?=\S)/gi, ', ')
    },
    director () {
      return _.get(this.contentInfo, 'director', '').replaceAll(/,(?=\S)/gi, ', ')
    },
    genres () {
      return _.get(this.contentInfo, 'genres', '').replaceAll(/,(?=\S)/gi, ', ')
    },
    image () {
      return _.get(this.contentInfo, 'image', '')
    },
    imgAlt () {
      return _.get(this.contentInfo, 'title', '')
    },
    movieId () {
      return _.get(this.contentInfo, 'movieid', '')
    },
    programId () {
      return _.get(this.contentInfo, 'programid', '')
    },
    releaseDate () {
      return _.get(this.contentInfo, 'releasedate', '')
    },
    synopsis () {
      return _.get(this.contentInfo, 'synopsis', '')
    },
    targetAge () {
      return _.get(this.contentInfo, 'targetage', '')
    },
    title () {
      return _.get(this.contentInfo, 'title', '')
    },
    isVod () {
      return this.contentType === 'vod'
    },
    hasActor () {
      return this.actor !== ''
    },
    hasDirector () {
      return this.director !== ''
    },
    hasGenres () {
      return this.genres !== ''
    },
    hasReleaseDate () {
      return this.releaseDate !== ''
    },
    hasSynopsis () {
      return this.synopsis !== ''
    },
    tableList () {
      const vod = [
        { title: '장르', key: 'genres', value: this.genres, isShow: this.hasGenres },
        { title: '감독', key: 'director', value: this.director, isShow: this.hasDirector },
        { title: '출연진', key: 'actor', value: this.actor, isShow: this.hasActor },
        { title: '줄거리', key: 'synopsis', value: this.synopsis, isShow: this.hasSynopsis }
      ]
      const movie = [
        { title: '감독', key: 'director', value: this.director, isShow: this.hasDirector },
        { title: '출연진', key: 'actor', value: this.actor, isShow: this.hasActor },
        { title: '개봉일', key: 'releaseDate', value: this.releaseDate, isShow: this.hasReleaseDate },
        { title: '줄거리', key: 'synopsis', value: this.synopsis, isShow: this.hasSynopsis }
      ]
      return this.isVod ? vod : movie
    }
  },
  methods: {
    goToContentDetail () {
      const IS_MOBILE_WEB = this.device === 'mobile'
      const query = this.isVod ? { programid: this.programId } : { movieid: this.movieId }
      const path = `/player/${this.isVod ? 'vod' : 'movie'}`

      if (IS_MOBILE_WEB) {
        this.$router.push({
          path: path,
          query: query
        })
      } else {
        location.href = `captvpooq:/${path}?${stringify(query)}`
      }
    }
  }
}
</script>
<style scoped lang="scss">
  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 400;
  }
  .tag-age{
    position: absolute;
    top: 5px;
    left: 5px;
  }
  .event-con-list {
    position: relative;
    width: 100%;
    height: auto;
    display: block;
    padding: 20px 0;
    border-bottom: 1px solid #2f2f2f;
  }
  .event-con-list-anchor {
    display: flex;
    flex-direction: row;
  }
  .event-con-list .picture-area {
    width: 85px;
  }
  .event-con-list .picture-area picture {
    display: block;
  }
  .event-con-desc-wrap {
    flex: 1;
    margin-left: 15px;
    display: flex;
    flex-direction: column;
  }
  .event-con-desc-wrap table{
    width: 100%;
    table-layout: fixed;
  }
  .event-con-desc{
    position: relative;
    display: block;
    color: #717171;
  }
  .event-con-tit{
    margin-bottom: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    font-size: 13px;
    line-height: 18px;
    color: #fff;
  }
  .event-desc-strong,
  .event-desc-detail{
    font-size: 13px;
    line-height: 1.38em;
  }
  .event-desc-strong{
    display: inline-block;
    min-width: 24px;
    margin-right: 15px;
    font-weight: 400;
    color: #a5a5a5;
  }
  .event-desc-detail{
    color: #a5a5a5;
  }
  .event-desc-director,
  .event-desc-actor {
    display: flex;
    th {
      vertical-align: top;
    }
    td {
      display: -webkit-box;
      margin-left: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      word-wrap: break-word;
      -webkit-line-clamp: 1;
    }
  }
  .event-synopsis td{
    display: block;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    -webkit-line-clamp: 5;
    margin-left: 0;
  }
  .event-tag-age{
    position: absolute;
    top: 5px;
    right: 5px;
  }
</style>
